import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FamilyTree from '../components/FamilyTree';

const HomePage = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await axios.get('/api/family-members');
        setMembers(res.data);
      } catch (err) {
        console.error("Failed to load family members:", err);
        setError("Could not connect to server. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchMembers();
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen font-sans">

      {/* --- UNDER DEVELOPMENT SCROLLING BANNER --- */}
      <div className="bg-amber-400 text-amber-900 py-2 shadow-sm border-b border-amber-500 relative z-40">
        <marquee 
          behavior="scroll" 
          direction="left" 
          scrollamount="10" 
          className="font-bold text-sm md:text-base tracking-wide uppercase"
        >
          ⚠️ The website is currently under development. Kindly refrain from entering or submitting any information until an official launch announcement is made. ⚠️
        </marquee>
      </div>

      {/* LIGHT HERO SECTION */}
      <section className="bg-white border-b border-gray-200 py-32">
        <div className="max-w-4xl mx-auto px-6 text-center">
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-4 tracking-tight">
            कै. गोविंद भास्कर खाडिलकर यांच्या वंशावळीची वेबसाईट
          </h1>

          <p className="text-gray-600 text-xl md:text-2xl mb-10 italic">
            कै. श्रीपाद व्यंकटेश खाडिलकर यांचे स्मरणार्थ
          </p>

          <button
            onClick={() => document.getElementById('tree-view')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-blue-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-700 shadow-lg shadow-blue-600/30 transition-all hover:-translate-y-0.5"
          >
            Explore Family Tree
          </button>
        </div>
      </section>

      {/* FAMILY TREE SECTION - Expanded for maximum screen usage */}
      <section id="tree-view" className="py-12 md:py-16">
        
        {/* CHANGED: Stretches to 98% of the monitor width instead of being restricted to max-w-7xl */}
        <div className="w-full max-w-[98%] xl:max-w-[95%] mx-auto px-4 md:px-8">

          <div className="text-center mb-10">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-4 tracking-tight">
              Family Lineage
            </h2>
            <p className="text-gray-500 text-lg">
              Interactive view of our history and connections.
            </p>
          </div>

          {loading ? (
            <div className="flex flex-col items-center justify-center py-24">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-blue-600 mb-6"></div>
              <p className="text-gray-500 font-semibold tracking-wide text-sm">Loading Generations...</p>
            </div>
          ) : error ? (
            <div className="max-w-lg mx-auto text-center py-10 text-red-600 bg-red-50 rounded-xl border border-red-100">
              <h3 className="font-bold text-xl mb-2">Error Loading Data</h3>
              <p className="text-red-500">{error}</p>
            </div>
          ) : (
            /* CHANGED: h-[80vh] makes the box scale to 80% of the user's screen height */
            <div className="bg-white rounded-2xl shadow-xl shadow-gray-200/50 p-4 md:p-8 border border-gray-100 overflow-auto h-[80vh] w-full relative">
              <FamilyTree members={members} />
            </div>
          )}

        </div>
      </section>
    </div>
  );
};

export default HomePage;









//Working 
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import FamilyTree from '../components/FamilyTree';

// const HomePage = () => {
//   const [members, setMembers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchMembers = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const res = await axios.get('/api/family-members');
//         setMembers(res.data);
//       } catch (err) {
//         console.error("Failed to load family members:", err);
//         setError("Could not connect to server. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchMembers();
//   }, []);

//   return (
//     <div className="bg-gray-50 min-h-screen font-sans">

//       {/* LIGHT HERO SECTION */}
//       <section className="bg-white border-b border-gray-200 py-32">
//         <div className="max-w-4xl mx-auto px-6 text-center">
          
//           <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-4 tracking-tight">
//             कै. गोविंद भास्कर खाडिलकर यांच्या वंशावळीची वेबसाईट
//           </h1>

//           <p className="text-gray-600 text-xl md:text-2xl mb-10 italic">
//             कै. श्रीपाद व्यंकटेश खाडिलकर यांचे स्मरणार्थ
//           </p>

//           <button
//             onClick={() => document.getElementById('tree-view')?.scrollIntoView({ behavior: 'smooth' })}
//             className="bg-blue-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-700 shadow-lg shadow-blue-600/30 transition-all hover:-translate-y-0.5"
//           >
//             Explore Family Tree
//           </button>
//         </div>
//       </section>

//       {/* FAMILY TREE SECTION - Expanded for maximum screen usage */}
//       <section id="tree-view" className="py-12 md:py-16">
        
//         {/* CHANGED: Stretches to 98% of the monitor width instead of being restricted to max-w-7xl */}
//         <div className="w-full max-w-[98%] xl:max-w-[95%] mx-auto px-4 md:px-8">

//           <div className="text-center mb-10">
//             <h2 className="text-4xl font-extrabold text-gray-900 mb-4 tracking-tight">
//               Family Lineage
//             </h2>
//             <p className="text-gray-500 text-lg">
//               Interactive view of our history and connections.
//             </p>
//           </div>

//           {loading ? (
//             <div className="flex flex-col items-center justify-center py-24">
//               <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-blue-600 mb-6"></div>
//               <p className="text-gray-500 font-semibold tracking-wide text-sm">Loading Generations...</p>
//             </div>
//           ) : error ? (
//             <div className="max-w-lg mx-auto text-center py-10 text-red-600 bg-red-50 rounded-xl border border-red-100">
//               <h3 className="font-bold text-xl mb-2">Error Loading Data</h3>
//               <p className="text-red-500">{error}</p>
//             </div>
//           ) : (
//             /* CHANGED: h-[80vh] makes the box scale to 80% of the user's screen height */
//             <div className="bg-white rounded-2xl shadow-xl shadow-gray-200/50 p-4 md:p-8 border border-gray-100 overflow-auto h-[80vh] w-full relative">
//               <FamilyTree members={members} />
//             </div>
//           )}

//         </div>
//       </section>
//     </div>
//   );
// };

// export default HomePage;